import type { FormField, FormFields } from '../../common/types/form/form-fields';
import type { ApiFieldDataResponse } from '../types/field-data';
import type { ApiFormChoicesResponse } from '../types/form-choices';
import type { FormAnswers, FormQuestion, FormStatus } from '../types/proforma-form';
import { convertQuestion } from './convert-question';

export const convertQuestions = (
	questions: Record<string, FormQuestion>,
	answers?: FormAnswers,
	formStatus?: FormStatus,
	fieldData?: ApiFieldDataResponse,
	formChoices?: ApiFormChoicesResponse,
	shouldApplyDefaultValues?: boolean,
): FormFields => {
	const fieldEntries = Object.entries(questions).map(
		([questionId, question]): [string, FormField] => [
			questionId,
			convertQuestion(
				question,
				answers?.[questionId],
				formStatus,
				fieldData,
				formChoices,
				shouldApplyDefaultValues,
			),
		],
	);

	return Object.fromEntries(fieldEntries);
};
